module.exports = __webpack_public_path__ + "static/media/tono-mensaje-3-.fb742da.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tono-mensaje-3-.mp3
// module id = XYj5
// module chunks = 1